import classNames from 'classnames';
import load from '@/assets/images/load.gif';
import classes from './Loader.module.scss';

export const Loader = () => {
  return (
    <div className={classNames(classes.fade, classes.show)}>
      <div className={classes.container}>
        <img alt="Loading..." src={load} />
      </div>
    </div>
  );
};
